export default __webpack_public_path__ + "static/media/wetu.efcd3a70.svg";